import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewSelectSnapshot} from '@ngxs-labs/select-snapshot';
import {AppState} from '../../../../../state/app/app.state';
import {AuthState} from '../../../../../state/auth/auth.state';
import {User} from '../../../../../models/api/user.model';
import {Store} from '@ngxs/store';
import {NavService} from '../../../../../services/nav.service';
import {NavItemCodes} from '../../../../../enums/nav-item-codes.enum';
import {NavItemNode} from '../../../../shared/components/nav-items/nav-item';

@Component({
    selector: 'app-sidebar-content',
    templateUrl: './sidebar-content.component.html',
    styleUrls: ['./sidebar-content.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SidebarContentComponent implements OnInit {
    @ViewSelectSnapshot(AppState.layoutSmall) layoutSmall: boolean;
    @ViewSelectSnapshot(AuthState.currentUser) user: User;
    @Input() items: NavItemNode[];
    @Input() padded = false;
    @Output() clickItem = new EventEmitter();
    userItems: NavItemNode[] = [
        {
            main: NavService.get(NavItemCodes.PASSWORD_CHANGE),
        },
        {
            main: NavService.get(NavItemCodes.LOGOUT),
        },
    ];

    constructor(
        protected store: Store,
        protected navService: NavService
    ) {}

    ngOnInit() {
        this.items = this.navService.getNavItemNodes();
    }
}
